const accountingDE = {
    "view": {
        "table": {
            "title": "Buchhaltungsliste",
            "column": {
                "release": "Veröffentlichung",
                "period": "Zeitraum",
                "royalties": "Tantiemen",
                "costs": "Kosten",
                "net_revenue": "Nettoumsatz",
                "status": "Status",
                "accounting_report": "Buchhaltungsbericht",
                "details": "Details"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "button": {
                "statusCreating": "Erstellen",
                "statusGenerating": "Generieren",
                "statusGenerated": "Generiert",
                "statusNotGenerated": "Nicht generiert",
                "open": "Öffnen",
                "downloadPDF": "PDF herunterladen",
                "generatingPDF": "PDF wird generiert",
                "exportCsv": "CSV exportieren"
            }
        },
        "message": {
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filter",
                "monthRange": "Monatsbereich",
                "release": "Veröffentlichung"
            },
            "options": {
                "allReleases": "Alle Veröffentlichungen"
            },
            "placeholder": {
                "startingMonth": "Startmonat",
                "endingMonth": "Endmonat"
            },
            "button": {
                "generate": "Buchhaltungsbericht erstellen",
                "reset": "Filter zurücksetzen"
            },
            "table": {
                "title": "Einnahmen verfügbar für die Buchhaltung",
                "columns": {
                    "month": "Monat",
                    "year": "Jahr",
                    "revenue": "Einnahmen",
                    "status": "Status"
                },
                "label": {
                    "status_open": "Offen",
                    "status_accounted": "Abgerechnet",
                    "month_january": "Januar",
                    "month_february": "Februar",
                    "month_march": "März",
                    "month_april": "April",
                    "month_may": "Mai",
                    "month_june": "Juni",
                    "month_july": "Juli",
                    "month_august": "August",
                    "month_september": "September",
                    "month_october": "Oktober",
                    "month_november": "November",
                    "month_december": "Dezember"
                }
            }
        },
        "modal": {
            "header": "Buchhaltung hinzufügen",
            "body": "Sind Sie sicher, dass Sie eine neue Buchhaltung für Veröffentlichung: {{release}}, ZEITRAUM: {{startingMonth}} BIS {{endingMonth}} hinzufügen möchten?"
        },
        "message": {
            "success": "Buchhaltung wurde erstellt!",
            "errorSomethingWentWrong": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "errorNoEarningsAvailable": "Keine Einnahmen für die Buchhaltung verfügbar.",
            "errorNoReleaseSelected": "Bitte wählen Sie eine bestimmte Veröffentlichung für die Buchhaltung aus."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Buchhaltungsaufschlüsselung",
                "column": {
                    "revenueShareHolder": "Anteilseigner",
                    "revenue": "Netto-Tantiemen des Anteilseigners",
                    "reportPdf": "PDF herunterladen",
                    "action": "Aktion",
                    "emailSent": "E-Mail gesendet"
                },
                "label": {
                    "downloadPDF": "PDF herunterladen",
                    "generatingPDF": "PDF wird generiert"
                },
                "button": {
                    "exportCsv": "CSV exportieren"
                },
                "modal": {
                    "confirm": {
                        "header": "Bericht an Anteilseigner senden",
                        "body": "Sind Sie sicher, dass Sie den Bericht an den Anteilseigner senden möchten?",
                        "message": {
                            "success": "Bericht erfolgreich gesendet!"
                        },
                        "button": {
                            "cancel": "Abbrechen",
                            "confirm": "Bestätigen"
                        }
                    }
                },
                "message": {
                    "success": "Buchhaltungsbericht wurde gesendet!",
                    "errorSomethingWentWrong": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
                    "errorEmailNotPresent": "E-Mail für Anteilseigner nicht vorhanden!",
                    "errorNoReportAvailable": "Kein Bericht für diese Veröffentlichung verfügbar."
                }
            }
        }
    }
};

export default accountingDE;